import React, {Component} from "react";
import {withRouter, RouteComponentProps, Link} from "react-router-dom";
import {connect} from "react-redux";
import _ from "lodash";
import Moment from "moment";

import "./SystemSpecDetail.component.scss";
import Accordion from "../../../../../utils/Accordion/Accordion.component";

export interface SystemSpecDetailProps extends RouteComponentProps {
    specification: any;
}

class SystemSpecDetail extends Component<SystemSpecDetailProps, {}> {
    constructor(props) {
        super(props);
    }

    beautifyString = string => {
        if (string.toLowerCase() == "ip") {
            return "IP";
        }

        if (string.toLowerCase() == "id") {
            return "ID";
        }

        if (string.toLowerCase() == "os") {
            return "OS";
        }
        if (string.toLowerCase() == "serveruuid") {
            return "Server UUID";
        }

        let strippedString = string.replace(/_/g, " ").replace(/-/g, " ");
        let beautifiedString = strippedString.replace(/([A-Z])/g, " $1");
        return beautifiedString;
    };

    renderArray = json => {
        return (
            <div className="accordion-step">
                {json.map((item, index) => {
                    let title = item.hasOwnProperty("name")
                        ? this.beautifyString(item.name)
                        : `Item ${index + 1}`;
                    return (
                        <Accordion key={`${title}-${index}`} title={title}>
                            {this.renderJson(item)}
                        </Accordion>
                    );
                })}
            </div>
        );
    };

    renderJson = json => {
        let arrayKeys = [];
        let objectKeys = [];
        let stringKeys = [];
        Object.keys(json).map(key => {
            if (Array.isArray(json[key]) && json[key].length > 0) {
                arrayKeys.push(key);
            } else if (typeof json[key] === "object" && json[key] !== null) {
                objectKeys.push(key);
            } else {
                stringKeys.push(key);
            }
        });
        delete json.wave_rsa_publickey;

        return (
            <div className="accordion-step">
                {Object.keys(json).map(key => {
                    if (stringKeys.includes(key)) {
                        if (typeof json[key] === "boolean") {
                            return (
                                <p key={`${key}-${json[key]}`}>
                                    {this.beautifyString(key)}:{" "}
                                    <span>
                                        {json[key] == true ? "Yes" : "No"}
                                    </span>
                                </p>
                            );
                        }

                        if (json[key] != null) {
                            let isDate = Moment(
                                json[key].toString().slice(0, -3),
                                "YYYY-MM-DD HH:mm:ss.SSS",
                                true
                            ).isValid();

                            return (
                                <p key={`${key}-${json[key]}`}>
                                    {this.beautifyString(key)}:{" "}
                                    <span>
                                    {isDate
                                        ? Moment(json[key]).format(
                                            "YYYY-MM-DD HH:mm:ss"
                                        )
                                        : json[key]}
                                </span>
                                </p>
                            );
                        }
                    }
                })}
                {Object.keys(json).map(key => {
                    if (arrayKeys.includes(key)) {
                        return (
                            <Accordion
                                key={`${key}-${json[key]}`}
                                title={this.beautifyString(key)}
                            >
                                {this.renderArray(json[key])}
                            </Accordion>
                        );
                    } else if (objectKeys.includes(key)) {
                        return (
                            <Accordion
                                key={`${key}-${json[key]}`}
                                title={this.beautifyString(key)}
                            >
                                {this.renderJson(json[key])}
                            </Accordion>
                        );
                    }
                })}
            </div>
        );
    };

    render() {
        if (this.props.specification == null) {
            return null;
        }

        return (
            <div className="panel-specification-detail">
                <div>
                    <h1>Specification Detail</h1>
                    <div>
                        <div className="accordion-step">
                            <p>
                                Inserted At:{" "}
                                <span>
                                    {Moment(
                                        this.props.specification["inserted_at"]
                                    ).format("YYYY-MM-DD HH:mm:ss")}
                                </span>
                            </p>
                        </div>
                        <Accordion title="Server Configuration">
                            {this.renderJson(
                                this.props.specification["server"]
                            )}
                        </Accordion>
                        <Accordion title="Specifications">
                            {this.renderJson(this.props.specification["specs"])}
                        </Accordion>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SystemSpecDetail));
